module.exports = __webpack_public_path__ + "img/logo_combined.35a4c8d3.png";